import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// packages/react/id/src/id.tsx
import * as React from "react";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
var useReactId = React["useId".toString()] || function () {
  return void 0;
};
var count = 0;
function useId(deterministicId) {
  var _React$useState = React.useState(useReactId()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    id = _React$useState2[0],
    setId = _React$useState2[1];
  useLayoutEffect(function () {
    if (!deterministicId) setId(function (reactId) {
      return reactId !== null && reactId !== void 0 ? reactId : String(count++);
    });
  }, [deterministicId]);
  return deterministicId || (id ? "radix-".concat(id) : "");
}
export { useId };